import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('MEDIAVIEWER_MEDIA').plugin(axiosPlugin);

let fetchMediaviewerMediaAction = redux.fetchActionGetOne();

redux.reducerForType('ADD_LIKE', (state,payload) => {
    let newState = {...state};
    newState.data.count.like++;
    return newState;
});

redux.reducerForType('DELETE_LIKE', (state,payload) => {
    let newState = {...state};
    newState.data.count.like--;
    if(newState.data.count.like < 0 ){
        newState.data.count.like = 0;
    }
    return newState;
});

export const TYPES = redux.types;

export const fetchMediaviewerMedia = (mediaId, query = {}) => fetchMediaviewerMediaAction(`/medias/${mediaId}?${queryString.stringify(query)}`);
export const resetMediaviewerMedia = () => redux.actions.reset();

export const mediaviewerMedia = redux.reducer();